export const VoteTypes = {
    SHOW_POLL_BY_ID: "SHOW_POLL_BY_ID",
    SEND_VOTE: "SEND_VOTE"
    // UPDATE_POLL: "UPDATE_POLL",
};
